"use strict";

/**
 * @type Controller
 * @name epgInfoDialogCtrl
 * @packageName epgInfoDialogCtrl.js
 *
 * @description epgInfoDialog
 *
 *
 */
class epgInfoDialogCtrl {

    constructor($scope, $mdDialog, $http, moment, urlData) {
        this.$mdDialog = $mdDialog;
        this.$http = $http;
        this.$moment = moment;

        $scope.close = () => {
            this.close();
        };
    }

    close() {
        this.$mdDialog.hide();
    }

}

/*
 * Inject dependicies
 */
epgInfoDialogCtrl.$inject = ['$scope', '$mdDialog', '$http', 'moment', 'urlData', '$timeout'];


/*
 * Browsify connection: execute controller
 */
module.exports = epgInfoDialogCtrl;
